import { useQuery } from '@tanstack/react-query';
import { supabase } from '../lib/supabase';

/**
 * Hook to fetch the count of paying Founders Promo customers
 * Counts companies with active Stripe Connect accounts (paying $20/month)
 * Always adds 2 to the count to account for the first 2 locations that are already signed up
 * This ensures we never show 0/100, and the count reflects actual signups beyond the initial 2
 */
export function useFoundersPromoCount() {
  return useQuery({
    queryKey: ['founders-promo-count'],
    queryFn: async () => {
      const { count, error } = await supabase
        .from('companies')
        .select('id', { count: 'exact', head: true })
        .eq('stripe_connect_onboarding_complete', true)
        .eq('stripe_connect_account_status', 'active');

      if (error) {
        console.error('[useFoundersPromoCount] Error fetching count:', error);
        // Return 2 as default even on error (the initial 2 locations)
        return 2;
      }

      // Always add 2 to the count to account for the first 2 locations
      // This ensures we show at least 2/100 and count actual signups beyond that
      const actualCount = count || 0;
      // Add 2 to always show the first 2 locations, plus any new signups
      return actualCount + 2;
    },
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    refetchInterval: 5 * 60 * 1000, // Refetch every 5 minutes
  });
}
